import React, { useCallback, useEffect, useState } from 'react';
import { Tabs, Tab, Box, Button, Grid2, CardContent, Card, Typography } from '@mui/material';
import SearchBox from '../../../components/form/SearchBox/SearchBox';
import { ENTITYTYPE, ModuleNames, SEARCHBOX } from '../../../data/constants';
import NewMessage from './NewMessage';
import InternalMessages from './InternalMessages';
import AddIcon from "@mui/icons-material/Add";
import { INTERNALMESSAGES } from '../../../constants/messages';
import "./MessageTabs.scss";
import { useMenu } from '../../../context/MenuContext';
const MessageTabs: React.FC = () => {
    const [tabIndex, setTabIndex] = useState(0);
    const [isModalOpen, setModalOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchClearSignal, setSearchClearSignal] = useState(0);
    const [canEdit, setCanEdit] = useState(false);
    const [canRecall, setCanRecall] = useState(false);
    const { permissions } = useMenu();

    useEffect(() => {
        const messagePermission = permissions?.find(
            (permission) => permission.moduleName === ModuleNames.Messages
        );
        setCanEdit(messagePermission?.canEdit ?? false);
        setCanRecall(messagePermission?.canDelete ?? false);
    }, [permissions]);

    useEffect(() => {
        if (!canRecall && tabIndex === 2) {
            setTabIndex(0);
        }
    }, [canRecall, tabIndex]);

    const activeTabIndex = canRecall || tabIndex < 2 ? tabIndex : 0;

    const handleSearchChange = useCallback((text: string) => {
        setRefreshKey(0);
        setSearchText(text);
    }, []);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setSearchClearSignal(prev => prev + 1);
        setSearchText("");
        setRefreshKey(0);
        setTabIndex(newValue);
    };

    const handleModalClose = (refresh: boolean) => {
        setModalOpen(false);
        if (refresh) {
            setRefreshKey(prev => prev + 1);
        }
    }

    return (
        <>
            <section className='mb-3'>
                <Card>
                    <CardContent>
                        <Typography id="messagesLabel" variant="h5" component="div" className="mb-3 card-title">{INTERNALMESSAGES.MESSAGES}</Typography>
                        <Grid2 container rowSpacing={1} mb={2} mt={1} justifyContent="space-between">
                            {canEdit && (
                                <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>
                                    <Button id="newMessage" variant="contained" className="add-new-btn" onClick={() => setModalOpen(true)}>
                                        <AddIcon /> New
                                    </Button>
                                    <NewMessage open={isModalOpen} onClose={handleModalClose} />
                                </Grid2>
                            )}
                            <Grid2
                                size={{ xs: 12, sm: 6, md: 4 }}
                                className="data-action-area"
                            >
                                <Box width="100%" className="search-box-wrap msg-search">
                                    <SearchBox searchPlaceholder={SEARCHBOX.TEXT_PLACEHOLDER}
                                        onSearch={handleSearchChange}
                                        clearSignal={searchClearSignal} />
                                </Box>
                            </Grid2>
                        </Grid2>

                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <Tabs value={activeTabIndex} onChange={handleTabChange} aria-label="Messaging Tabs">
                                <Tab label="Inbox" />
                                <Tab label="Sent" />
                                {canRecall && <Tab label={ENTITYTYPE.RECALL} />}
                            </Tabs>
                            <Box sx={{ width: '100%', mt: 2 }}>
                                {activeTabIndex === 0 && <InternalMessages type={ENTITYTYPE.INBOX} searchResult={searchText} refreshKey={refreshKey} />}
                                {activeTabIndex === 1 && <InternalMessages type={ENTITYTYPE.SENT} searchResult={searchText} refreshKey={refreshKey} />}
                                {canRecall && activeTabIndex === 2 && <InternalMessages type={ENTITYTYPE.RECALL} searchResult={searchText} refreshKey={refreshKey} />}
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </section>

        </>
    );
}
export default MessageTabs;